import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.AUTHENTICATION.VALIDATE_MAGIC_LINK,
  payload,
})
